namespace Areas.Analysis.TimeVerification {
    "use strict";

    let weekEndingDate: Date;

    export function getWeekEndingDate() {
        return moment(weekEndingDate).format("YYYY-MM-DD");
    }

    export function formReady(e: any) {
        weekEndingDate = getSaturday(new Date());
        e.component.option("formData", { selectedWeekEnding: weekEndingDate });
    }

    export function viewLink(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const startDate = String(cellInfo.data.weekEndingDate);
        const linkInfo = `<a href= '/Employee/Time/Index/${employeeId}?start=${startDate}' target=_blank >View</a>`; 
        cellElement.html(linkInfo);
    }

    export function load() {
        const form = $("#timeVerificationForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const data: any = form.option("formData");
            weekEndingDate = getSaturday(data.selectedWeekEnding);
            form.updateData("selectedWeekEnding", weekEndingDate)
            Areas.refreshGrid("timeVerificationGrid");
        }
    }

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setLockedByBackground(e);
        setSubmittedByBackground(e);
    }

    function setLockedByBackground(e) {
        var isApprovedDataCell = e.column.dataField === "supervisorApprovalBy";

        if (isApprovedDataCell) {
            if (e.data.supervisorApprovalBy == null) {
                e.cellElement.css("background-color", "yellow");
            }
        }
    }

    function setSubmittedByBackground(e) {
        var isApprovedDataCell = e.column.dataField === "submittedBy";

        if (isApprovedDataCell) {
            if (e.data.submittedBy == null) {
                e.cellElement.css("background-color", "yellow");
            }
        }
    }

    export function loadPrevWeek() {
        loadWeek(-1);
    }

    export function loadNextWeek() {
        loadWeek(1);
    }

    export function submitFromTimeVerification() {
        GridActionTimeVerification("Submit");
    }

    export function approveFromTimeVerification() {
        GridActionTimeVerification("Approve");
    }

    export function lockFromTimeVerification() {
        GridActionTimeVerification("Lock");
    }

    export function unSubmitFromTimeVerification() {
        GridActionTimeVerification("UnSubmit");
    }

    export function unApproveFromTimeVerification() {
        GridActionTimeVerification("UnApprove");
    }

    export function unLockFromTimeVerification() {
        GridActionTimeVerification("UnLock");
    }

    export function GridActionTimeVerification(urlAction: string) {
        const dataGrid = $('#timeVerificationGrid').dxDataGrid('instance');
        const selectedRows = dataGrid.getSelectedRowKeys().join(',');
        const url = `/Analysis/TimeVerification/${urlAction}?ids=${selectedRows}`;

        sendRequest(url, "", "POST", () => { Areas.refreshGrid("timeVerificationGrid")});
    }
    
    function loadWeek(offset) {
        const form = $("#timeVerificationForm").dxForm("instance");
        const data: any = form.option("formData");

        const saturday = getSaturday(data.selectedWeekEnding);
        weekEndingDate = moment(saturday).add(offset, "week").toDate();

        form.updateData("selectedWeekEnding", weekEndingDate);
        Areas.refreshGrid("timeVerificationGrid");
    }

    function getSaturday(date: Date)
    {
       let result = moment(date).startOf('day');

        while (result.day() != 6) {
            result.add(-1, "day");
        }

        return result.toDate();
    }
}